/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IFilterField } from "Interfaces/IFilterField";
import { IKeyText } from "Interfaces/IKeyText";

import { fieldTypes } from "./FilterFields";

export const defaultListingPageSize = 16;

export enum VisualStudioBenefitStatusEnum {
  Assign = "Assigned",
  Remove = "Removed",
}

const AWARD_PERIOD = "awardPeriod";
const BENEFIT_STATUS = "benefitStatus";
const EXPIRATION_START_DATE = "expirationStartDate";
const EXPIRATION_END_DATE = "expirationEndDate";

export const visualStudioBenefitStatus: IKeyText[] = [
  {
    key: "assign",
    text: VisualStudioBenefitStatusEnum.Assign,
  },
  {
    key: "remove",
    text: VisualStudioBenefitStatusEnum.Remove,
  },
];

/**
 * Sidebar filter constants used for
 * visual studio benefits filtering.
 */
export const visualStudioBenefitFilterFields: IFilterField[] = [
  {
    key: AWARD_PERIOD,
    text: "Award Period",
    type: fieldTypes.AWARD_PERIOD,
  },
  {
    key: BENEFIT_STATUS,
    text: "Benefit Status",
    type: fieldTypes.MULTI_SELECT,
    options: visualStudioBenefitStatus,
  },
  {
    key: EXPIRATION_START_DATE,
    text: "Expiration Start Date",
    type: fieldTypes.DATE_PICKER,
  },
  {
    key: EXPIRATION_END_DATE,
    text: "Expiration End Date",
    type: fieldTypes.DATE_PICKER,
  },
];

/**
 * Default filter values for visual studio benefits.
 */
export const defaultVisualStudioBenefitFilterValues: {
  fieldName: string;
  value: string;
}[] = [];
